import { Chip } from "@mui/material";

const ChargeSessionStatus = ({ chargeSession }: { chargeSession: ChargeSession }) => {
  const statusLabel: {
    [key: string]: string;
  } = {
    completed: "Completed",
    charging: "Charging",
    holding: "Holding",
    fee_calculating: "Fee Calculating",
    noshow: "No Show",
    canceled: "Canceled",
    "": "-",
  };
  const colors: {
    [key: string]:
    | "success"
    | "info"
    | "error"
    | "warning"
    | "default"
    | "primary"
    | "secondary";
  } = {
    completed: "success",
    charging: "warning",
    holding: "warning",
    fee_calculating: "warning",
    noshow: "warning",
    canceled: "error",
    "": "warning",
  };
  return (
    <Chip
      style={{ maxWidth: "70%", fontSize: "8px", width: "82px" }}
      label={statusLabel[chargeSession.status || ""]}
      size="small"
      color={colors[chargeSession.status || ""]}
    />
  );
};

export default ChargeSessionStatus;